import React from 'react';
import { ButtonGroup } from '@common/components';
import { ComplianceItemActionsUploadNew } from './_compliance-item-actions-upload-new';
import { ComplianceItemActionsAcceptReject } from './_compliance-item-actions-accept-reject';

export function ComplianceItemDrawerFooter({
  onFinished,
  canUpdate,
  canApproveReject,
  complianceItemId,
  complianceItemState,
  complianceItemHasAnyFile,
}: {
  onFinished: () => void;
  canUpdate: boolean;
  canApproveReject: boolean;
  complianceItemId: string;
  complianceItemState: string;
  complianceItemHasAnyFile: boolean;
}) {
  if (!canUpdate && !canApproveReject) {
    return false;
  }

  return (
    <ButtonGroup>
      {canUpdate && (
        <ComplianceItemActionsUploadNew complianceItemId={complianceItemId} />
      )}
      {canApproveReject && (
        <ComplianceItemActionsAcceptReject
          onFinished={onFinished}
          complianceItemId={complianceItemId}
          complianceItemState={complianceItemState}
          complianceItemHasAnyFile={complianceItemHasAnyFile}
        />
      )}
    </ButtonGroup>
  );
}
